import React from "react";

//components
import Icon from "../../../../Icon/Icon";
import { IProviderAddon } from "../../../../../../compare/interfaces/IProviderAddon";

//styles
import styles from "./ResultAIAVitality.module.scss";


interface IResultAIAVitalityProps {
    providerAddOn: IProviderAddon;
}

const ResultAIAVitality: React.FC<IResultAIAVitalityProps> = (props) => {
    const { providerAddOn } = props;

    return (
        <div className={"layout-flex-column"}>
            <div className={styles["container_row"]}>
                <Icon className="space-m gap-pre-s icon-vitality" id="AiaVitality" />
                {providerAddOn.fee > 0 &&
                    <React.Fragment>
                        <span>12-month membership fee cashback</span>
                    <div className={styles["container_fee"]}>
                        <strong className="text-brand">+ {`$${providerAddOn.fee}`}</strong>
                        </div>
                    </React.Fragment>
                }
            </div>
            <span className="gap-pre-m text-small text-light">
                {providerAddOn.quoteAmountInfoText}
                <a className="space-pre-m" href="/article/lifedirect-aia-vitality-offer" target="_blank">More info</a>
            </span>
        </div>
    );
};

export default ResultAIAVitality;
